import { Component, OnInit, Input } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';

@Component({
  selector: 'app-location-hours',
  templateUrl: './location-hours.component.html',
  styleUrls: ['./location-hours.component.css']
})
export class LocationHoursComponent implements OnInit {

 constructor( private homepageService: HomepageService ) {}
 locationHour: any = [];
 @Input() buId: number;
 ngOnInit() {
 	this.getLocationHour();
 }

 getLocationHour(){
    let getwidgetsSettingDataSave =  this.homepageService.getwidgetsSettingDataSave();
    getwidgetsSettingDataSave.data.forEach(evt => {
            if(evt.code == 'LL' && this.buId  == evt.id) {
               this.locationHour = evt.settings;                             
             }            
          });     
    }

}
